import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  ListProps,
  Modal,
  Row,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
  deleteTranscriptionItem,
  getBotTranscriptionSingeFile,
  recoverTranscriptionFile,
  updateTranscriptionText,
} from '../../../services/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ListItemProps } from '../../../types/List';
import List from '../../../coreComponents/List';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import CommonTypeAhead from '../../formsAndTable/forms/formWidgets/typeAhead/common/CommonTypeAhead';
import { OptionItems } from '../../../types/Forms';
import { Option } from 'react-bootstrap-typeahead/types/types';
import { Primary } from '../../../constants';
import { getSocketSessionId } from '../../../hooks/useSocket';
import { BotTranscriptionItem } from '../../../types/Bot';
type SpeakerRow = { speaker?: string | null };
const BotTranscription = () => {
  const { transcriptId } = useParams<{ transcriptId: string }>();
  const [transcriptionFile, setTranscriptionFile] = useState<ListProps>({
    listData: [],
  });
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editText, setEditText] = useState<ListItemProps>({ text: '', speaker: '', timestamp: '' });
  const [modalState, setModalState] = useState<'edit' | 'create'>('create');
  const [speaker, setSpeaker] = useState<OptionItems | { name: '' }>({ name: '' });
  const [speakersList, setSpeakersList] = useState<{ name: string; id: number }[]>([]);
  const [eventDate, setEventDate] = useState<Date | null>(new Date());
  const [transcriptionHasChanges, setTranscriptionHasChanges] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);
  const fetchTranscriptionFiles = async () => {
    try {
      const res = await getBotTranscriptionSingeFile(transcriptId);
      const result = res.fileContent.sort((a: { timestamp: string }, b: { timestamp: string }) => {
        return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
      });

      const transcriptionListData = {
        listData: result,
      };
      setTranscriptionFile(transcriptionListData || null);

      const uniqueSpeakers: { name: string; id: number }[] = [];
      const seen = new Map<string, number>();

      result.forEach((r: SpeakerRow, idx: number) => {
        const name = r.speaker?.trim();
        if (!name) return;
        if (seen.has(name)) return; // already added
        seen.set(name, idx); // remember where we first saw it
        uniqueSpeakers.push({ name, id: idx });
      });

      setSpeakersList(uniqueSpeakers);
    } catch (err) {
      console.error('Failed to load transcription files', err);
    }
  };
  useEffect(() => {
    fetchTranscriptionFiles();
  }, []);

  const handleEditText = (item: ListItemProps) => {
    setModalState('edit');
    setIsEditOpen(true);
    setEditText({
      id: item.id,
      speaker: item.speaker,
      text: item?.text ? item?.text : '',
      timestamp: item.timestamp,
    });
  };

  const handleInputChange = (text: string) => {
    setEditText({ ...editText, text: text });
  };
  const handleEditTextSubmit = async (updateData: ListItemProps) => {
    setTranscriptionHasChanges(true);
    const updatedListData = transcriptionFile.listData.map((item: ListItemProps) =>
      item.id === updateData.id ? { ...item, text: updateData.text } : item,
    );
    setTranscriptionFile({ ...transcriptionFile, listData: updatedListData });
    try {
      setIsEditOpen(false);
      // const res = await updateTranscriptionText(transcriptId, updateData);
      // setIsEditOpen(false);
      // if (res)
      //   Swal.fire({
      //     title: t('global.success'),
      //     text: t('bot.transcriptionTextUpdate'),
      //     icon: 'success',
      //     confirmButtonText: 'OK',
      //   });
      // else {
      //   Swal.fire({
      //     title: t('global.error'),
      //     text: t('bot.transcriptionTextUpdateFail'),
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //   });
      // }
    } catch (error) {
      Swal.fire({
        title: t('global.error'),
        text: t('bot.transcriptionTextUpdateFail'),
        icon: 'error',
        confirmButtonText: 'OK',
      });
      setIsEditOpen(false);
      return;
    }
  };

  const handleConfirmDeleteItem = (deleteData: ListItemProps) => {
    Swal.fire({
      title: t('bot.deleteTranscriptConfirm'),
      text: t('bot.deleteTranscriptText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Primary,
    }).then((result) => {
      if (result.isConfirmed) handleDeleteItem(deleteData);
      else Swal.fire({ text: t('bot.deleteTranscriptRejectText') });
    });
  };
  const handleDeleteItem = async (deleteData: ListItemProps) => {
    try {
      const res = await deleteTranscriptionItem(transcriptId, deleteData.id);
      const result = res.remaining.sort((a: { date: string }, b: { date: string }) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });

      const transcriptionListData = {
        listData: result,
      };
      setTranscriptionFile(transcriptionListData || null);
      if (res)
        Swal.fire({
          title: t('global.success'),
          text: t('bot.transcriptionTextRemove'),
          icon: 'success',
          confirmButtonText: 'OK',
        });
      else {
        Swal.fire({
          title: t('global.error'),
          text: t('bot.transcriptionTextRemoveFail'),
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      Swal.fire({
        title: t('global.error'),
        text: t('bot.transcriptionTextRemoveFail'),
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };
  const handleOpenCreate = () => {
    setModalState('create');
    setEditText({
      id: uuidv4(),
      speaker: '',
      text: '',
      timestamp: '',
    });
    setIsEditOpen(true);
  };
  const handleAddTextSubmit = async (speaker: string, date: Date, text: string) => {
    const timeStapm = date.toISOString().replace(/\.\d{3}Z$/, 'Z'); // e.g. 2025-08-04T17:30:00Z
    const newTranscript = {
      id: uuidv4(),
      speaker: speaker,
      text: text,
      timestamp: timeStapm,
    };
    setEditText(newTranscript);
    const updatedListData = [...transcriptionFile.listData, newTranscript].sort(
      (a: { timestamp: string }, b: { timestamp: string }) => {
        return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
      },
    );
    setTranscriptionFile({ ...transcriptionFile, listData: updatedListData });
    setTranscriptionHasChanges(true);

    setIsEditOpen(false);
  };
  const handleBack = () => {
    const from = location.state?.from || '/exams/bot';
    navigate(from);
  };

  const handleDateChange = (date: Date) => {
    setEventDate(date);
  };

  const handleSpeakerSelect = async (selected: Option[]) => {
    if (selected.length > 0 && typeof selected[0] === 'object' && 'id' in selected[0]) {
      const speaker = selected[0] as OptionItems;
      setSpeaker(speaker);
    } else {
      setSpeaker({ name: '' });
    }
  };

  const handleUpdateTranscriptionFile = async () => {
    const sessionId = getSocketSessionId();
    try {
      const res = await updateTranscriptionText(transcriptId, {
        fileContent: transcriptionFile.listData,
        sessionId,
      });
      if (res) {
        Swal.fire({
          title: t('global.success'),
          text: t('bot.transcriptionFileUpdateSuccess'),
          icon: 'success',
          confirmButtonText: 'OK',
        });
        setTranscriptionHasChanges(false);
      } else {
        Swal.fire({
          title: t('global.error'),
          text: t('bot.transcriptionFileUpdateFail'),
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('Failed to update transcription file', error);
    }
  };

  const handleRecoverTranscription = async () => {
    try {
      const data = await recoverTranscriptionFile(transcriptId);
      console.log('Recovered transcription file data', data);
      if (data) {
        Swal.fire({
          title: t('global.success'),
          text: t('bot.transcriptionFileRecoverSuccess'),
          icon: 'success',
          confirmButtonText: 'OK',
        });
        const result = data
          .sort((a: { timestamp: string }, b: { timestamp: string }) => {
            return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
          })
          .map((item: BotTranscriptionItem) => ({
            id: uuidv4(),
            speaker: item.speaker_name,
            text: item.transcription.transcript,
            timestamp: item.timestamp_ms,
          }));

        const transcriptionListData = {
          listData: result,
        };
        setTranscriptionFile(transcriptionListData || null);
        setTranscriptionHasChanges(true);
      } else {
        Swal.fire({
          title: t('global.error'),
          text: t('bot.error.transcriptionFileRecoverFail'),
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('Failed to recover transcription file', error);
      Swal.fire({
        title: t('global.error'),
        text: t('bot.error.transcriptionFileRecoverFail'),
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    // Implement the logic to recover the transcription file
    // This could involve calling an API endpoint to restore the file to its last saved state or to a previous version.
  };

  return (
    <>
      <Breadcrumbs mainTitle={t('bot.botPageHeader')} />
      <Container fluid>
        <Row>
          <Card>
            {' '}
            <CardBody>
              <Row className="mb-3">
                <Col sm="4">
                  {' '}
                  <Button onClick={handleBack}>{t('global.back')}</Button>
                  <Button color="primary" className="ms-2" onClick={handleRecoverTranscription}>
                    {t('bot.recoverTranscription')}
                  </Button>
                </Col>
              </Row>

              <Col sm="8">
                <List
                  data={transcriptionFile}
                  handleEditText={handleEditText}
                  handleDeleteItem={handleConfirmDeleteItem}
                  handleOpenCreate={handleOpenCreate}
                  hasNewCommetsToSave={transcriptionHasChanges}
                  handleSyncChanges={handleUpdateTranscriptionFile}
                />
              </Col>
            </CardBody>{' '}
          </Card>
        </Row>
      </Container>
      <Modal isOpen={isEditOpen} toggle={() => setIsEditOpen(false)} centered size="lg">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Form
                  className="theme-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // setTotalTranscriptItemsUpdate((prev) => [
                    //   ...prev,
                    //   {
                    //     id: editText.id ?? undefined,
                    //     speaker: speaker?.name ?? '',
                    //     text: editText.text ?? '',
                    //     timestamp: eventDate ? eventDate.toISOString() : '',
                    //   },
                    // ]);
                    if (modalState === 'edit') handleEditTextSubmit(editText);
                    else
                      handleAddTextSubmit(
                        speaker?.name ?? '',
                        eventDate ?? new Date(),
                        editText.text ?? '',
                      );
                  }}
                >
                  {modalState === 'create' && (
                    <>
                      {speakersList && (
                        <CommonTypeAhead
                          id="speaker"
                          title={t('bot.selectSpeaker')}
                          // subTitle={BloodHoundSubTitle}
                          options={speakersList}
                          placeholder={t('assistantExam.createForm.user')}
                          labelKey="name"
                          onChange={(selected) => handleSpeakerSelect(selected)}
                        />
                      )}
                      {/* <Label htmlFor="speaker">Speaker </Label> */}
                      {/* <Input
                        id="speaker"
                        type="text"
                        value={speaker}
                        onChange={(e) => setSpeaker(e.target.value)}
                        className="mb-4"
                      /> */}
                      <Label htmlFor="eventMoment">{t('bot.selectDateTime')}</Label>
                      <DatePicker
                        id="eventMoment"
                        className="form-control mb-3"
                        selected={eventDate}
                        onChange={(date) => handleDateChange(date ?? new Date())}
                        showTimeSelect
                        timeFormat="HH:mm:ss"
                        timeCaption="time"
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        timeIntervals={1}
                      />
                    </>
                  )}
                  <Label htmlFor="tr-text">{t('bot.transcriptionText')}</Label>
                  <Input
                    id="tr-text"
                    type="textarea"
                    rows={5}
                    value={editText.text}
                    onChange={(e) => handleInputChange(e.target.value)}
                  />
                  <Row className="mt-3">
                    <Col sm="6" className="d-flex gap-3">
                      <Button type="submit" color="primary" outline>
                        {t('global.ok')}
                      </Button>
                      <Button
                        type="button"
                        onClick={() => {
                          setEditText({ text: '', speaker: '', timestamp: '' });
                          setSpeaker({ name: '' });
                          setEventDate(new Date());
                          setIsEditOpen(false);
                        }}
                        color="danger"
                        outline
                      >
                        {t('global.cancel')}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default BotTranscription;
